/**
 * 个股详情页面固底导航
 */
import React, { useEffect, useState } from "react"
import { StockAddIcon, StockDeleteIcon, StockMoreIcon, StockPostIcon, StockShareIcon, StockTradeIcon } from "../icon"
import { quotedata } from "../quotedata"
import "./index.less"
import { gubaCodeChange } from "../utils"
import { StockMoreNav } from "../stock_more_nav"
import "./index.less"
import { ShareStock } from "../share_stock"
import { ZXPop } from "../zx_pop"
import newzxg from "../../../modules/newzxg/web"
import { loadZsData } from "../../../modules/quote/web"
import { IndicesPopPanel } from "../zhishu_pop"
import { isWeChat } from "../utils"
import { PageType, StockSubType } from "../pagetype"
import { single_quote, quote_item_name } from "../quotedata/index"

export function StockFixedFooter(props: { quotedata: quotedata; pagetype: PageType,stocksubtype?:StockSubType }) {
  const [tradeBtnVisible, setTradeBtnVisible] = useState(false)
  const [shareBtnVisible, setShareBtnVisible] = useState(true)
  const [moreBtnVisible, setMoreBtnVisible] = useState(true)
  const [addStockBtnVisible, setAddStockBtnVisible] = useState(true)
  const [stockMoreVisible, setStockMoreVisible] = useState(false)
  const [sharePanelVisible, setSharePanelVisible] = useState(false)
  const [addStockVisible, setAddStockVisible] = useState(false)

  const [indicesTabVisible, setIndicesTabVisible] = useState(false)
  const [indicesPanelVisible, setIndicesPanelVisible] = useState(false)
  const [indicesData, setIndicesData] = useState<any>({})
  const [trangleClass, setTrangleClass] = useState(false)

  const isWx = isWeChat()

  const clickTrade = () => {
    window.location.href = "//wap.eastmoney.com/h52n?type=502&market=" + (props.quotedata.market == 1 ? "SH" : "SZ") + "&code=" + props.quotedata.code
  }

  const postMessage = () => {
    let oldUrl = location.href
    location.href = "http://mguba.eastmoney.com/mguba/newpost/" + gubaCodeChange(props.quotedata.code) + "/" + encodeURIComponent(oldUrl)
  }

  const clickMore = () => {
    if(indicesPanelVisible){
      setIndicesPanelVisible(false)
    }
    if (stockMoreVisible) {
      setStockMoreVisible(false)
    } else {
      setStockMoreVisible(true)
    }
  }

  const clickShare = () => {
    if (stockMoreVisible) {
      setStockMoreVisible(false)
    }
    setSharePanelVisible(true)
  }

  const clickAddStock = () => {
    setAddStockVisible(true)
  }

  const AddStock = () => {
    newzxg
      .addDefaultStock(props.quotedata.quotecode)
      .then((back) => {
        if (back.re) {
          setAddStockBtnVisible(false)
        } else {
          alert(back.message)
        }
      })
      .catch(() => {})
  }

  const clickDeleteStock = () => {
    newzxg.deleteDefaultStock(props.quotedata.quotecode).then(function (back) {
      if (back.re) {
        setAddStockBtnVisible(true)
      } else {
        alert(back.message)
      }
    })
    return false
  }

  const clickIndices = () => {
    if (stockMoreVisible) {
      setStockMoreVisible(false)
    }
    if (indicesPanelVisible) {
      setIndicesPanelVisible(false)
      setTrangleClass(false)
    } else {
      setIndicesPanelVisible(true)
      setTrangleClass(true)
    }
  }


  useEffect(() => {
    ;(async () => {
      //自选股默认分组id
      await newzxg.checkHasAdd(props.quotedata.quotecode).then((data: any) => {
        if (data.result) {
          setAddStockBtnVisible(false)
        } else {
          setAddStockBtnVisible(true)
        }
      })
    })()
    
    if (props.pagetype == PageType.沪深A股 || props.pagetype == PageType.沪深京指数 || props.pagetype == PageType.债券 || (props.pagetype == PageType.期货 && props.stocksubtype == StockSubType.商品期货) || props.pagetype == PageType.B股 || props.pagetype == PageType.choice指数) {
      setIndicesTabVisible(true)
      // 上证弹窗
      ;(async () => {
        let data = await loadZsData("000001", 1, "")
        setIndicesData(data)
      })()
    }

    // 交易按钮
    if (/^\d{6}$/.test(props.quotedata.code) && ((props.quotedata.market == 1 && props.quotedata.code.indexOf("000") != 0) || (props.quotedata.market == 0 && props.quotedata.code.indexOf("399") != 0))) {
      setTradeBtnVisible(true)
    }

    // 分享、更多按钮
    if (props.quotedata.market == 1 || props.quotedata.market == 0) {
      setShareBtnVisible(false)
    } else {
      setMoreBtnVisible(false)
    }

    // 加自选、删自选按钮
    if (props.quotedata.market == 1 || props.quotedata.market == 0 || props.quotedata.market == 113) {
      setAddStockBtnVisible(true)
    }
  }, [props.quotedata.quotecode])

  return (
    <>
      {!isWx && (
        <>
          <div className="stock-footer">
            <div className="wrap">
              {indicesTabVisible && (
                <div className="zhishu-data" onClick={clickIndices}>
                  <i className={`icon-trangle ${trangleClass?"rotate":""}`}></i>
                  <p>{single_quote[quote_item_name.最新价_指数](indicesData).element}</p>
                  <p>
                    {single_quote[quote_item_name.名称_指数](indicesData).element}&nbsp;
                    {single_quote[quote_item_name.涨跌幅_指数](indicesData).element}
                  </p>
                </div>
              )}

              <ul>
                {tradeBtnVisible && (
                  <li onClick={(e)=>{e.preventDefault();clickTrade()}}>
                    <div className="wrap-stock-trade">
                      <StockTradeIcon />
                    </div>
                    <p>交易</p>
                  </li>
                )}

                <li onClick={(e)=>{e.preventDefault();postMessage()}}>
                  <div className="wrap-stock-post">
                    <StockPostIcon />
                  </div>
                  <p>发帖</p>
                </li>
                {moreBtnVisible && (
                  <li onClick={(e)=>{e.preventDefault();clickMore()}}>
                    <div className="wrap-stock-more">
                      <StockMoreIcon />
                    </div>
                    <p>更多</p>
                  </li>
                )}
                {shareBtnVisible && (
                  <li
                    onClick={(e) => {
                      e.preventDefault()
                      clickShare()
                    }}
                  >
                    <div className="wrap-stock-share">
                      <StockShareIcon />
                    </div>
                    <p>分享</p>
                  </li>
                )}
                {addStockBtnVisible ? (
                  <li
                    onClick={(e) => {
                      e.preventDefault()
                      clickAddStock()
                    }}
                  >
                    <div className="wrap-stock-add">
                      <StockAddIcon />
                    </div>
                    <p>加自选</p>
                  </li>
                ) : (
                  <li
                    onClick={(e) => {
                      e.preventDefault()
                      clickDeleteStock()
                    }}
                  >
                    <div className="wrap-stock-delete">
                      <StockDeleteIcon />
                    </div>
                    <p>删自选</p>
                  </li>
                )}
              </ul>
            </div>
          </div>
          {indicesPanelVisible && <IndicesPopPanel pagetype={props.pagetype} quotedata={props.quotedata} data={indicesData} setIndicesData={setIndicesData} onClose={() => setIndicesPanelVisible(false)} setTrangleClass={setTrangleClass}/>}
          {stockMoreVisible && <StockMoreNav quotedata={props.quotedata} onClose={() => setStockMoreVisible(false)} />}
          {sharePanelVisible && <ShareStock quotedata={props.quotedata} onClose={() => setSharePanelVisible(false)} />}
          {addStockVisible && <ZXPop quotedata={props.quotedata} onClose={() => setAddStockVisible(false)} cancelEvent={AddStock} />}
        </>
      )}
    </>
  )
}
